const unwrapEl = (el) => {
  if (!el) {
    return;
  }
  if (typeof el !== "object") {
    return;
  }
  if (typeof el.$el !== "undefined") {
    return el.$el;
  }
  return el;
};
export {
  unwrapEl as u
};
//# sourceMappingURL=unwrapEl-4d79d250.mjs.map
